export enum EPrivacyStatus {
  Normal = -1,
  UserPageNoPermission = 0,
  UserPageHasPermission = 1,
  PrivateUser = 2,
  UnderAge = 3,
}
